import { render, staticRenderFns } from "./examIndex.vue?vue&type=template&id=ff52e7a0&scoped=true"
import script from "./examIndex.vue?vue&type=script&lang=js"
export * from "./examIndex.vue?vue&type=script&lang=js"
import style0 from "./examIndex.vue?vue&type=style&index=0&id=ff52e7a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff52e7a0",
  null
  
)

export default component.exports